import moment from "moment"
import { CurrencyFormat } from "../../../../components/helpers"
import IsEmpty from "../../../../components/helpers/IsEmpty"

export const getOngoingVa = (data) => {
    let ongoingVa = {}
    let transaction = []
    if (data.length < 1) return

    data.gadai_transactions.map(item => {
        if (!IsEmpty(item.gadai_transfer) && item.status === 'waiting-transfer' && item.type_transaction === 'payment-loan') {
            if (item.gadai_transfer.is_midtrans && item.gadai_transfer.type_transfer === 'in') {
                transaction.push({
                    date: moment(item.transaction_time).format('DD/MM/YYYY HH:mm'),
                    receipt: data?.offer?.paymentType === 'Installment' ? [...item.gadai_transaction_installment.map(e => e.receipt_code)]
                        .join(", ") : data?.receipt_code,
                    bank: item.gadai_transfer.office_bank_name,
                    totalPayment: `Rp ${CurrencyFormat(item.total)}`,
                    va: item.gadai_transfer.office_account_number,
                    periodNumber: [...item.gadai_transaction_installment.map(e => e.gadai_installment.period_number)]
                        .join(", "),
                    purpose: data?.offer?.paymentType === 'Installment'
                        ? `Cicilan ${[...item.gadai_transaction_installment.map(e => e.gadai_installment.period_number)].join(", ")}`
                        : 'Pembayaran Tagihan'
                })
            }
        }
    })
    ongoingVa = {
        customerName: data.ktp_name,
        sbg: data.sbg_code,
        transaction
    }
    return ongoingVa
}